import { memo } from 'react';

// Modules
import { formatHeadline, setInnerHTML } from '@/lib/util';

type Props = {
  productName: string;
};

const ProductHeading = memo(({ productName }: Props) => (
  <h2
    className="product-headline format--marketing-headline"
    dangerouslySetInnerHTML={setInnerHTML(formatHeadline(productName))}
  >
    {null}
  </h2>
));

ProductHeading.displayName = 'ProductHeading';

export { ProductHeading };
